export enum VacuumCategory {
  NiBaseEquiax = "Nickel Base Equiax",
  NiDirectionallySolidified = "Nickel Base Directionally Solidified",
  NiSingleCrystal = "Nickel Base Single Crystal",
  CobaltBase = "Cobalt Base",
  Unknown = "Unknown"
}

export interface VacuumAlloy {
  id: number;
  category: VacuumCategory;
  cannonMuskegonTitle: string;
  aerospaceMaterialSpecifications: string | null;
  prattAndWhitney: string | null;
  generalElectric: string | null;
  rollsRoycePlc: string | null;
  rollsRoyceCorp: string | null;
  honeywell: string | null;
  safran: string | null;
  carbon: number | null;
  cobalt: number | null;
  chromium: number | null;
  tungsten: number | null;
  niobium: number | null;
  tantalum: number | null;
  titanium: number | null;
  aluminum: number | null;
  boron: number | null;
  zirconium: number | null;
  hafnium: number | null;
  iron: number | null;
  rhenium: number | null;
  other: string | null;
  densityMetric: number | null;
  densityImperial: number | null;
  solidusF: number | null;
  liquidousF: number | null;
  solidusC: number | null;
  liquidousC: number | null;
}

export enum AirMeltCategory {
  CarbonAndLowAlloySteels = "Carbon & Low Alloy Steels",
  StainlessSteels = "Stainless Steels",
  NickelBase = "Nickel Base Alloys",
  CobaltBase = "Cobalt Base Alloys",
  CastToolSteels = "Cast Tool Steels"
}

export interface AirMeltAlloy {
  id: number;
  category: AirMeltCategory;
  cannonMuskegonTitle: string | null;
  commonName: string | null;
  tradeName: string | null;
  astm: string | null;
  aerospaceMaterialSpecifications: string | null;
  uns: string | null;
  din: string | null;
  wNr: string | null;
  afnor: string | null;
  carbon: number | null;
  manganese: number | null;
  silicon: number | null;
  chromium: number | null;
  nickel: number | null;
  molybdenum: number | null;
  phosphorus: number | null;
  sulfur: number | null;
  vanadium: number | null;
  tungsten: number | null;
  cobalt: number | null;
  copper: number | null;
  iron: number | null;
  other: string | null;
  solidusF: number | null;
  liquidousF: number | null;
}
